import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ButtonComponent } from '@finder/shared/components/button/button.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { LiveAnnouncerService } from '@finder/shared/services/a11y/live-announcer.service';

@Component({
    selector: 'finder-filter-pills',
    templateUrl: './filter-pills.component.html',
    styleUrls: ['./filter-pills.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        ButtonComponent
    ]
})
export class FilterPillsComponent {
    @Input() pills;
    @Input() clearLabel: string;
    @Input() pillsWrapperLabel: string;
    @Input() pillAriaLabel: string;
    @Input() clearAriaLive: string;
    @Input() pillAriaLive: string;
    @Output() clear: EventEmitter<boolean> = new EventEmitter<boolean>(false);
    @Output() pillClose: EventEmitter<any> = new EventEmitter();

    constructor(private a11yLiveService: LiveAnnouncerService) {}

    getPillAriaLabel(label: string) {
        return this.pillAriaLabel.replace('{label}', label);
    }

    clearPills(): void {
        this.clear.emit(true);
        if (this.clearAriaLive) {
            this.a11yLiveService.announce(this.clearAriaLive);
        }
    }

    closePill(pill): void {
        this.pillClose.emit(pill);
        if (this.pillAriaLive) {
            this.a11yLiveService.announce(`${pill.label} ${this.pillAriaLive}`);
        }
    }
}
